// zkStatus.ts

export interface ZKStatusResponse {
    code: number;
    data: {
      status: number;
    } | null;
  }
  
  export async function getZKStatus(address: string): Promise<ZKStatusResponse> {
    const defaultResponse: ZKStatusResponse = {
      code: 1,
      data: null
    };
  
    try {
      const res = await fetch(`https://api.zkportal.org/status?address=${address}`);
      if (!res.ok) throw new Error("error");
  
      const json = await res.json();
  
      if (json && typeof json.code === "number" && json.data) {
        return json;
      }
  
      return defaultResponse;
    } catch (error) {
      console.warn("getZKStatus error:", error);
      return defaultResponse;
    }
  }